import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { DashboardManagerComponent } from './pages/dashboard-manager/dashboard-manager.component';
import { DashboardEngineerComponent } from './pages/dashboard-engineer/dashboard-engineer.component';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { AuthGuard } from './auth.guard';
import { PagesComponent } from './pages/pages.component';
import { RoleGuard } from './role.guard';
import { AnalysisComponent } from './pages/dashboard-engineer/analysis/analysis.component';
import { OverviewComponent } from './pages/dashboard-engineer/overview/overview.component';
import { AnalysisManagerComponent } from './pages/dashboard-manager/analysis-manager/analysis-manager.component';
import { OverviewManagerComponent } from './pages/dashboard-manager/overview-manager/overview-manager.component';
// import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NotFoundComponent } from './pages/miscellaneous/not-found/not-found.component';
import { PartInfoComponent } from './pages/part-info/part-info.component';
import { ProjectViewComponent } from './pages/project-view/project-view.component';
import { SmartSyncComponent } from './pages/smart-sync/smart-sync.component';
import { PartAlertComponent } from './pages/part-alert/part-alert.component';
import { DashboardAdminComponent } from './pages/dashboard-admin/dashboard-admin.component';
import { PartSyncComponent } from './pages/part-sync/part-sync.component';
import { AdminAnalysisComponent } from './pages/dashboard-admin/admin-analysis/admin-analysis.component';
import { AdminOverviewComponent } from './pages/dashboard-admin/admin-overview/admin-overview.component';
import { KeycloakComponent } from './components/keycloak/keycloak.component';
import { VendorMappingComponent } from './pages/vendor-mapping/vendor-mapping.component';


// Helper function to check the role
function getUserRole(): string | null {
  return sessionStorage.getItem('role');
}

export const routes: Routes = [
  // { path: 'manager-dashboard', component: DashboardManagerComponent, canActivate: [AuthGuard], data: { role: 'Manager' } },
  // { path: 'engineer-dashboard', component: DashboardEngineerComponent, canActivate: [AuthGuard], data: { role: 'Engineer' } },
  // // { path: '**', redirectTo: '/login' }, // Redirect to login for undefined routes
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  // { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'keycloak', component: KeycloakComponent },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'auth',
    // component: NbAuthComponent,
    component: PagesComponent,
    canActivate: [AuthGuard, RoleGuard], // Protect this route
    canActivateChild: [AuthGuard, RoleGuard], // Protect child routes
    // children: [
    //   // {
    //   //   path: '',
    //   //   component: NbLoginComponent,
    //   // },
    //   {
    //     path: 'login',
    //     component: NbLoginComponent,
    //   },
    //   {
    //     path: 'register',
    //     component: NbRegisterComponent,
    //   },
    //   {
    //     path: 'logout',
    //     component: NbLogoutComponent,
    //   },
    //   {
    //     path: 'request-password',
    //     component: NbRequestPasswordComponent,
    //   },
    //   {
    //     path: 'reset-password',
    //     component: NbResetPasswordComponent,
    //   },
    // ],
      children: [
        {
          path: 'login', component: LoginComponent
        },
        // Conditionally show or hide routes based on role
        // ...(role === 'Manager' ? [
          // {
          //   path: 'dashboard-manager',
          //   component: DashboardManagerComponent,
          //   canActivate: [AuthGuard, RoleGuard],
          //   data: { role: 'Manager' },
          // },

          // Manager-specific routes
          {
            path: 'dashboard-manager',
            component: DashboardManagerComponent,
            canActivate: [AuthGuard, RoleGuard],
            data: { role: getUserRole() === 'Manager' ? 'Manager' : '' },
          },
          {
            path: 'dashboard-manager/analysis',
            component: AnalysisManagerComponent,
            canActivate: [AuthGuard, RoleGuard],
            // data: { role: 'Manager' },
            data: { role: getUserRole() === 'Manager' ? 'Manager' : '' },
          },
          {
            path: 'dashboard-manager/overview',
            component: OverviewManagerComponent,
            canActivate: [AuthGuard, RoleGuard],
            // data: { role: 'Manager' },
            data: { role: getUserRole() === 'Manager' ? 'Manager' : '' },
          },
        // ] : []),
    
        // ...(role === 'Engineer' ? [
          {
            path: 'dashboard-engineer',
            component: DashboardEngineerComponent,
            canActivate: [AuthGuard, RoleGuard],
            // data: { role: 'Engineer' },
            data: { role: getUserRole() === 'Engineer' ? 'Engineer' : '' },
          },
          {
            path: 'vendar',
            component: VendorMappingComponent,
            canActivate: [AuthGuard, RoleGuard],
            // data: { role: 'Engineer' },
            data: { role: getUserRole() === 'Engineer' ? 'Engineer' : '' },
          },
          {
            path: 'dashboard-engineer/overview',
            component: OverviewComponent,
            canActivate: [AuthGuard, RoleGuard],
            // data: { role: 'Engineer' },
            data: { role: getUserRole() === 'Engineer' ? 'Engineer' : '' },
          },
          {
            path: 'dashboard-engineer/analysis',
            component: AnalysisComponent,
            canActivate: [AuthGuard, RoleGuard],
            // data: { role: 'Engineer' },
            data: { role: getUserRole() === 'Engineer' ? 'Engineer' : '' },
          },
        // ] : []),

        // Admin-specific routes
        {
          path: 'dashboard-admin',
          component: DashboardAdminComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { role: getUserRole() === 'Admin' ? 'Admin' : '' },
        },
        // {
        //   path: 'dashboard-admin/analysis',
        //   component: AdminAnalysisComponent,
        //   canActivate: [AuthGuard, RoleGuard],
        //   // data: { role: 'Manager' },
        //   data: { role: getUserRole() === 'Admin' ? 'Admin' : '' },
        // },
        // {
        //   path: 'dashboard-admin/overview',
        //   component: AdminOverviewComponent,
        //   canActivate: [AuthGuard, RoleGuard],
        //   // data: { role: 'Manager' },
        //   data: { role: getUserRole() === 'Admin' ? 'Admin' : '' },
        // },
    
        {
          path: 'project-view',
          component: ProjectViewComponent,
          canActivate: [AuthGuard, RoleGuard],
          // data: { role: 'Engineer' }, 
          data: { role: getUserRole() === 'Engineer' ? 'Engineer' : '' },         
        },
        {
          path: 'project-view',
          component: ProjectViewComponent,
          canActivate: [AuthGuard, RoleGuard],
          // data: { role: 'Manager' },    
          data: { role: getUserRole() === 'Manager' ? 'Manager' : '' },      
        },
        // {
        //   path: 'part-info',
        //   component: PartInfoComponent,
        // },
        {
          path: 'part-info',
          component: PartInfoComponent,
          canActivate: [AuthGuard, RoleGuard], 
          data: { role: getUserRole() === 'Manager' || getUserRole() === 'Engineer' ? getUserRole() : '' },
        },
        {
          path: 'smart-sync',
          component: SmartSyncComponent,
          canActivate: [AuthGuard, RoleGuard], 
          data: { role: getUserRole() === 'Manager' || getUserRole() === 'Engineer' ? getUserRole() : '' },
        },
        {
          path: 'part-sync',
          component: PartSyncComponent,
          canActivate: [AuthGuard, RoleGuard], 
          data: { role: getUserRole() === 'Manager' || getUserRole() === 'Engineer' ? getUserRole() : '' },
        },
        {
          path: 'part-alert',
          component: PartAlertComponent,
          canActivate: [AuthGuard, RoleGuard], 
          data: { role: getUserRole() === 'Manager' || getUserRole() === 'Engineer' ? getUserRole() : '' },
        },
       
        // {
        //   path: 'iot-dashboard',
        //   component: DashboardComponent,
        // },
        {
          path: '',
          redirectTo: 'dashboard',
          pathMatch: 'full',
        },
        {
          path: '**',        
          component: NotFoundComponent,
        },
      ],
  },
  // { path: '', redirectTo: 'pages', pathMatch: 'full' },
  // { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: false,
  onSameUrlNavigation: 'reload', // Force reload on same URL
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
